import { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import Swal from 'sweetalert2'
import api from '../../../config/AxiosInstance.js'
import * as Common from '../../../utils/Common.js'
import CustomButton from '../../Button/CustomButton.jsx'

function ModalAddSelectStagingArea(props) {
  const labelCheckboxActive = {
    border: '1px solid transparent',
    backgroundColor: '#F2f2f2',
    padding: '1rem',
    marginTop: '.3rem',
    width: '100%'
  }

  const labelCheckboxUnactive = {
    border: '1px solid transparent',
    backgroundColor: '#C9CACD',
    padding: '1rem',
    marginTop: '.3rem',
    width: '100%'
  }

  const [selectStagingArea, setSelectStagingArea] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [submitButton, setSubmitButton] = useState(false)
  const [stagings, setStagings] = useState([])
  const checkWarehouseBAJ = (value) => {
    return value?.includes('- BAJ') || false
  }
  const fetchStagingArea = async () => {
    try {
      setIsLoading(true)
      const res = await api.get('master/stagings/show', {
        params: {
          dest_warehouse: checkWarehouseBAJ(props.warehouseId)
            ? props.warehouseId
            : `${props.warehouseId} - BAJ` || ''
        }
      })
      if (res.status === 200) {
        setStagings(res.data.data)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (props.show) {
      fetchStagingArea()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show, props.warehouseId, props.inboundId])

  // event handler
  const handleSelectStaging = (e) => {
    const { value, checked } = e.target

    if (selectStagingArea.length + 1 > 2 && checked) {
      Swal.fire({
        icon: 'error',
        title: 'Sorry...',
        text: 'You can only select 2 staging area'
      })
      e.target.checked = false
      return
    }
    if (checked) {
      setSelectStagingArea((prevItems) => [...prevItems, value])
    } else {
      setSelectStagingArea((selectStagingArea) =>
        selectStagingArea.filter((stagingArea) => stagingArea !== value)
      )
    }
  }

  const handleSubmit = async () => {
    try {
      setSubmitButton(true)
      let values = {
        inbound_id: props.inboundId,
        stagings: selectStagingArea
      }
      let url = 'inbound/ml-draft/assign-staging'
      if (props.type === 'inbound-return') {
        url = `inbound/return/${props.inboundId}/staging`
      } else if (props.type === 'material-reject') {
        url = 'inbound/material-reject/assign_staging'
        const { inbound_id, ...rest } = values
        values = {
          ...rest,
          mr_id: props.inboundId
        }
      }
      const res = await api.post(url, values)
      if (res.data.success) {
        props.onHide()
        props.refreshData()
        Common.showPopUpSuccessMessage(res.data.message)
        setSelectStagingArea([])
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'

      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setSubmitButton(false)
    }
  }

  return (
    <Modal
      {...props}
      onHide={() => {
        props.onHide()
        setSelectStagingArea([])
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>Select Staging Area</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '80vh', overflow: 'auto' }}>
        <p style={{ color: '#C12727', paddingTop: '20px' }}>
          Please select carefully as this action cannot be repeated
        </p>
        {isLoading && (
          <div className="d-flex justify-content-center">
            <div className="spinner-border text-warning" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
        {!isLoading && stagings.length === 0 && (
          <div className="text-center">
            <p className="fw-bold">Staging Area Empty</p>
          </div>
        )}
        {!isLoading &&
          stagings.length > 0 &&
          stagings.map((data, index) => (
            <div
              key={index}
              className={`d-flex flex-row gap-3 ${
                index > 0 ? 'mt-2 form-check' : 'form-check'
              }`}
            >
              <div className="d-flex flex-column justify-content-center">
                <input
                  className="staging-area form-check-input fe-auto"
                  type="checkbox"
                  name="stagings"
                  value={data.id}
                  id={data.id}
                  disabled={data.is_used}
                  onChange={(e) => handleSelectStaging(e)}
                  role="button"
                  style={{ fontSize: '13px' }}
                />
              </div>
              <label
                className="form-check-label ml-3 fw-bold text-center text-uppercase"
                htmlFor={data.id}
                style={
                  data.is_used ? labelCheckboxUnactive : labelCheckboxActive
                }
              >
                {data.name}
              </label>
            </div>
          ))}

        <Modal.Footer className="mt-3">
          <CustomButton
            onClick={handleSubmit}
            variant={
              selectStagingArea.length === 0 || submitButton
                ? 'secondary'
                : 'warning'
            }
            disabled={
              selectStagingArea.length === 0 || submitButton ? true : false
            }
            text={submitButton ? 'Loading...' : 'Save'}
            classNameValue={`text-white ${
              selectStagingArea.length === 0 || submitButton ? 'opacity-50' : ''
            }`}
          />
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  )
}

export default ModalAddSelectStagingArea
